<template>

    <v-container fluid fill-height>
        <v-layout>

            <v-flex>

                <v-card>

                    <v-breadcrumbs divider="/">
                        <v-breadcrumbs-item to="/" :disabled="false">Početna</v-breadcrumbs-item>
                        <v-breadcrumbs-item to="/costs" :exact="true" :disabled="false">Unosi</v-breadcrumbs-item>
                        <v-breadcrumbs-item :disabled="true">Kreiranje</v-breadcrumbs-item>
                    </v-breadcrumbs>

                </v-card>

                <v-card class="fix-card">
                    <form>

                        <v-select
                                v-if="properties"
                                :items="properties"
                                label="Grupa"
                                v-model="cost.property_id"
                                :error="error_messages.property_id == false"
                                :error-messages="error_messages.property_id"
                                item-text="title"
                                item-value="id"
                        ></v-select>

                        <v-select
                                v-if="attributes"
                                :items="attributes"
                                label="Pod grupa"
                                v-model="cost.attribute_id"
                                :error="error_messages.attribute_id == false"
                                :error-messages="error_messages.attribute_id"
                                item-text="title"
                                item-value="id"
                        ></v-select>

                        <v-text-field
                                v-model="cost.value"
                                :error="error_messages.value == false"
                                :error-messages="error_messages.value"
                                label="Iznos"
                                required
                        ></v-text-field>

                        <v-text-field
                                v-model="cost.desc"
                                :error="error_messages.desc == false"
                                :error-messages="error_messages.desc"
                                label="Opis"
                                required
                        ></v-text-field>

                        <v-checkbox
                                label="Keš"
                                v-model="cost.cash"
                                color="primary"
                        ></v-checkbox>

                        <v-checkbox
                                label="Kartica"
                                v-model="cost.card"
                                color="primary"
                        ></v-checkbox>

                        <v-btn @click="submit()" color="primary">Potvrdi</v-btn>
                        <v-btn @click="clear()" color="secondary" class="black--text">Očisti</v-btn>

                    </form>
                </v-card>

            </v-flex>

        </v-layout>

    </v-container>

</template>

<script>
    import swal from 'sweetalert2';

    export default {
        data() {
            return {
                fillable: ['user_id', 'property_id', 'attribute_id', 'value', 'desc', 'cash', 'card',],
                cost: {},
                properties: false,
                attributes: false,
                error_messages: [],
            }
        },
        mounted(){
            this.getProperties();
        },
        computed: {
            userProfile(){
                return this.$store.getters['user/getUser'];
            },
        },
        methods: {
            getProperties(){
                axios.get('properties/lists')
                    .then(res => {
                        this.properties = res.data.properties;
                    })
                    .catch(e => {
                        console.log(e);
                        this.error = e.response.data.errors;
                    });
            },
            getAttributes(property_id){
              axios.get('attributes/lists?property_id=' + property_id)
                .then(res => {
                  this.attributes = res.data.attributes;
                })
                .catch(e => {
                  console.log(e);
                  this.error = e.response.data.errors;
                });
              },
            submit(){
                this.cost.user_id = this.userProfile.id;
                let data = fillForm(this.fillable, this.cost);
                axios.post('costs', data)
                    .then( res => {
                        swal({
                            position: 'center',
                            type: 'success',
                            title: 'Uspeh',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        this.$router.push('/costs');
                    })
                    .catch( e => {
                        this.error_messages = e.response.data;
                    });
            },
            clear(){
                this.attribute.property_id = '';
                this.attribute.attribute_id = '';
                this.attribute.value = '';
                this.attribute.cash = false;
                this.attribute.card = false;
                this.error_messages = [];
            },
        },
        watch: {
            'cost.property_id'(value){
                this.getAttributes(value);
            }
        },
    }
</script>
